var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.632,
    height: 20.037,
    viewBox: "0 0 19.632 20.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1198",
    "data-name": "Groupe 1198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_628",
    "data-name": "Trac\\xE9 628",
    d: "M-1485.608,1861.677h17.5a1.22,1.22,0,0,1,.75.246h0a.761.761,0,0,1,.312.591v18.359a.761.761,0,0,1-.312.591h0a1.218,1.218,0,0,1-.75.247h-17.5a1.218,1.218,0,0,1-.749-.247h0a.761.761,0,0,1-.312-.591v-18.359a.761.761,0,0,1,.312-.591h0a1.219,1.219,0,0,1,.749-.246Zm17.414.911h-17.322V1880.8h17.322Z",
    transform: "translate(1486.671 -1861.677)",
    fill: "#19c3b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_629",
    "data-name": "Trac\\xE9 629",
    d: "M-1471.141,1864.249h4.318a.71.71,0,0,1,.589.318.878.878,0,0,1,.155.5v9.491a1.106,1.106,0,0,1-.18.552.727.727,0,0,1-.187.187.577.577,0,0,1-.591.053.6.6,0,0,1-.3-.3l-1.637-2.977-1.657,3a.615.615,0,0,1-.324.284v0c-.019.007-.037.013-.056.018a.582.582,0,0,1-.52-.094.734.734,0,0,1-.189-.2,1.082,1.082,0,0,1-.161-.528v-9.491a.877.877,0,0,1,.155-.5.71.71,0,0,1,.589-.318Zm3.906,1.155h-3.5v7.45l1.231-2.229a.575.575,0,0,1,.243-.257.578.578,0,0,1,.784.228l-.506.278.505-.277,1.238,2.251Z",
    transform: "translate(1474.164 -1863.853)",
    fill: "#19c3b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.e6dce147d99146a39786abdd8d340691.svg";
export { ForwardRef as ReactComponent };